module.exports = __webpack_public_path__ + "img/person.426f20b3.png";